module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01#frontmatter01"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter02#frontmatter02"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part I. Toussaint Louverture")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Toussaint Louverture and the Family of Saint-Domingue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Under the Stick of Maître Toussaint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 “Free and French”: La Constitution de la colonie française de Saint-Domingue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Toussaint Louverture at a Crossroads: The "), _c('em', [_vm._v("Mémoire")]), _vm._v(" of the “First Soldier of the Republic of Saint Domingue”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part II. Aimé Césaire")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Césaire Reads Toussaint: The Haitian Revolution and the Problem of Departmentalization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Haitian Building: "), _c('em', [_vm._v("La tragédie du roi Christophe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Artisans of Free and French")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03#backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter04#backmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0